import React from 'react';
import VendorStoreManager from '../components/ShipturtleVendors/VendorStoreManager';
import styles from './Shipturtle.module.css';

function ShipturtleVendorStore() {
  return (
    <div className={styles.content}>
      <div className={styles.tabContent}>
        <VendorStoreManager />
      </div>
    </div>
  );
}

export default ShipturtleVendorStore;
